import { Instagram, Phone, MessageCircle } from "lucide-react";
import { BRAND, LOGO_URL, SLOGAN, PHONE_DISPLAY, INSTAGRAM_URL, INSTAGRAM_HANDLE, waLink, telLink } from "@/lib/contact";

export default function Footer() {
  return (
    <footer className="relative bg-navy-deep text-white/70 pt-20 pb-10 overflow-hidden grain" data-testid="footer">
      <div className="max-w-7xl mx-auto px-6 relative">
        <div className="flex flex-col md:flex-row justify-between gap-12 border-b border-white/10 pb-12">
          <div className="max-w-sm">
            <div className="flex items-center gap-3 mb-4">
              <img src={LOGO_URL} alt="زخرف" className="h-12 w-auto object-contain rounded-md" />
              <span className="text-gold text-xs">{SLOGAN}</span>
            </div>
            <p className="leading-relaxed text-sm">
              نصمّم دعوات إلكترونية راقية لكل مناسبة. تصفّح أعمالنا وتواصل معنا مباشرة
              عبر واتساب أو انستغرام لطلب تصميمك الخاص.
            </p>
          </div>
          <div className="flex flex-col gap-4">
            <h4 className="text-gold text-sm font-semibold">تواصل معنا</h4>
            <a href={waLink()} target="_blank" rel="noopener noreferrer" className="flex items-center gap-3 text-sm hover:text-gold transition-colors" data-testid="footer-whatsapp">
              <MessageCircle className="w-4 h-4" /> واتساب: {PHONE_DISPLAY}
            </a>
            <a href={telLink} className="flex items-center gap-3 text-sm hover:text-gold transition-colors" data-testid="footer-phone">
              <Phone className="w-4 h-4" /> اتصال: {PHONE_DISPLAY}
            </a>
            <a href={INSTAGRAM_URL} target="_blank" rel="noopener noreferrer" className="flex items-center gap-3 text-sm hover:text-gold transition-colors" data-testid="footer-instagram">
              <Instagram className="w-4 h-4" /> @{INSTAGRAM_HANDLE}
            </a>
          </div>
        </div>
        <div className="pt-8 flex flex-col md:flex-row justify-between items-center gap-4 text-xs text-white/50">
          <p>© {new Date().getFullYear()} {BRAND} — جميع الحقوق محفوظة.</p>
          <p className="font-serif text-gold/70">دعوات تليق بلحظاتك</p>
        </div>
      </div>
    </footer>
  );
}
